const cartSection = () => ({
  init() {
    this.loadTemplate();
  },

  loadTemplate() {
    const content = document
      .querySelector('.js-cart-template')
      .content.cloneNode(true);
    content.querySelector('.cart').classList.add('cart--section');
    this.$refs.target.replaceChildren(content);
  },
});

export default cartSection;
